import api from "../services/api";

export async function getDCatalogue(id) {
  return await api.get("/DCatalogue/GetEditModel", {
    params: {
      id: id,
    },
  });
}
